import React, { useContext } from "react";
import { Input } from "reactstrap";
import * as S from "./PersonalInformationStyle";
import text from "./data";
import ButtonsGroup from "../ButtonsGroup/ButtonsGroup";
import { AppContext } from "../../AppContext";

const PersonalInformation = (props) => {
  const { data, addSex, addListeningDevice, addAge } = useContext(AppContext);

  function isNormalInteger(str) {
    let n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
  }

  const validateInfo = () => {
    if (!data.sex) return props.updateErrorMessage("Palun vali sugu");
    if (!data.age) return props.updateErrorMessage("Palun sisesta vanus");
    if (!isNormalInteger(data.age))
      return props.updateErrorMessage("Vanus peab olema täisarv");
    if (data.age > 150) return props.updateErrorMessage("Vanus võimatult suur");
    if (!data.listeningDevice)
      return props.updateErrorMessage("Palun vali kuulamisseade");

    props.onForwardBtnClick();
  };

  const ButtonsPerson = () => {
    const ButtonValuesPerson = [
      { value: "M", title: "Mees" },
      { value: "N", title: "Naine" },
    ];

    return ButtonValuesPerson.map((res, index) => (
      <S.BootstrapButton
        key={index}
        color="primary"
        onClick={() => addSex(res.value)}
        active={data.sex === res.value}
      >
        {res.title}
      </S.BootstrapButton>
    ));
  };

  const ButtonsPhones = () => {
    const ButtonValuesPhones = [
      { value: "headphones", title: "Kõrvaklapid" },
      { value: "speakers", title: "Kõlarid" },
    ];

    return ButtonValuesPhones.map((res, index) => (
      <S.BootstrapButton
        key={index}
        color="primary"
        onClick={() => addListeningDevice(res.value)}
        active={data.listeningDevice === res.value}
      >
        {res.title}
      </S.BootstrapButton>
    ));
  };

  return (
    <S.Container>
      <S.Text>{text.textA}</S.Text>

      <S.BootstrapButtonGroup>
        <ButtonsPerson />
      </S.BootstrapButtonGroup>

      <S.Text>{text.textB}</S.Text>

      <Input
        id="ageInput"
        type={"number"}
        min="1"
        max="105"
        value={data.age}
        onChange={(e) => addAge(e.target.value)}
      />

      <S.Text>{text.textC}</S.Text>
      <S.Text>{text.textD}</S.Text>

      <S.BootstrapButtonGroup>
        <ButtonsPhones />
      </S.BootstrapButtonGroup>

      <ButtonsGroup
        onForwardBtnClick={validateInfo}
        onBackBtnClick={props.onBackBtnClick}
      />
    </S.Container>
  );
};

export default PersonalInformation;
